import type { ManifestEntry } from "@/types/zoteroImport";

// Conservative whitelist: only imported_file / imported_url PDFs are known to
// hold a Zotero-cloud blob. This is intentionally NARROWER than the backend
// ingest filter (which only excludes linked_file) — other/unknown link modes
// are treated as no-source so we never route a blob-less attachment to the
// cloud job (which would 404 per-item).
const CLOUD_LINK_MODES = new Set(["imported_file", "imported_url"]);

export type CloudAvailability = "cloud" | "no_source";

export function cloudAvailability(entry: ManifestEntry): CloudAvailability {
  if (
    entry.content_type === "application/pdf" &&
    entry.link_mode != null &&
    CLOUD_LINK_MODES.has(entry.link_mode)
  ) {
    return "cloud";
  }
  return "no_source";
}
